/**
 * Download content via anchor tag
 */
export const download = (content: string, fileName: string) => {
  const blob = new Blob([content]);

  const oLink = document.createElement('a');
  document.body.appendChild(oLink);
  oLink.download = fileName.replace(/\u201c|\u201d/g, '"');
  oLink.href = URL.createObjectURL(blob);
  oLink.click();
  document.body.removeChild(oLink);
};
